// @flow

import {extend} from '../../util/util';
import {FilterControlBase} from './filter_control_base';
import type {Options} from './filter_control_base';

type TrafficIncidentOptions =  Options & {
    incidentType: ?string
};

const defaultOptions: TrafficIncidentOptions = {
    id: 'trafficincidents',
    loadingEventId: 'trafficincident',
    isVisible: true,
    incidentType: 'All'
};

/**
 * The `TrafficIncidentFilterControl` adds the ability to filter the traffic incidents.
 *
 * @implements {IControl}
 * @param {Object} options
 * @param {string} [options.incidentType='All'] Filters results based on the incidentType ('All', 'incident', 'trafficjam', 'accident', 'weather', 'construction'). Default is 'All'.
 * @param {boolean} [options.isVisible=true] Controls the visiblity of the selection controls.
 *
 * @example
 * const trafficIncidentFilterControl = TrimbleMaps.TrafficIncidentFilterControl();
 * map.addControl(trafficIncidentFilterControl);
 */
class TrafficIncidentFilterControl extends FilterControlBase {
    constructor(options: TrafficIncidentOptions) {
        const opt = extend({}, defaultOptions, options);
        super(opt);
        const values = ['All', 'incident', 'trafficjam', 'accident', 'weather', 'construction'];
        let defaultFilter = values[0];
        if (values.indexOf(opt.incidentType) > -1) {
            defaultFilter = opt.incidentType;
        }
        this._layers = ['trafficincidents-traffic_incidents'];
        this._filterTitle = 'Traffic Incident';
        this._filterObjects = [{
            id: 'incidentType',
            label: 'Type',
            texts: ['All', 'Incident', 'Traffic', 'Accident', 'Weather', 'Construction'],
            values,
            default: defaultFilter
        }];
    }
}

export default TrafficIncidentFilterControl;
